const threshold = 0.01;

export const formatNumber = (value: number, fractionDigits = 2) => {
  if (fractionDigits && threshold > value && value > 0) {
    return `<${threshold}`;
  }

  return value.toLocaleString('en-US', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
};

const compactFormatter = new Intl.NumberFormat('en-US', {
  notation: 'compact',
  maximumFractionDigits: 2,
});

export const formatCompactNumber = (value: number) =>
  compactFormatter.format(value);
